const angular = require('angular');
const ngMessages = require('angular-messages');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
const olyDialog = require('oly-dialog');

const olyCommonModule = require('../olycommon/olycommon.module');
const wowCommonModule = require('../common/common.module');

const { recipeTileListComponentDefinition } = require('./recipe-tile-list.component');
const { recipeListTileListComponentDefinition } = require('./recipe-savedList/recipe-savedList-tile-list.component');

const recipeModuleName = 'wowApp.recipe';

angular.module(recipeModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular', olyDialog])
    .service('RecipeCategoriesService', ['Restangular', '$q', 'BootstrapService', require('./recipe-categories.service')])
    .service('RecipeService', ['Restangular', '$templateCache', 'BreakpointsService', require('./recipe.service')])
    .service('RecipeListsService', ['Restangular', require('./recipe-savedList/recipe-savedList.service')])
    .component('wowRecipeTileList', recipeTileListComponentDefinition)
    .component('wowRecipeListTileList', recipeListTileListComponentDefinition)
    .directive('wowRecipeSavedListNavigation', ['$state', 'RecipeListsService', 'ShopperService', require('./recipe-savedList/recipe-savedList-navigation.directive')])
    .component('wowRecipePrint', require('./recipe-print/recipe-print.component').recipePrintComponentDefinition)
    .component('wowRecipeTile', require('./recipetile/recipe-tile.component').recipeTileControllerComponentDefinition)
    .component('wowRecipeSaveToList', require('./recipesavetolist/recipe-save-to-list.component').recipeSaveToListComponentDefinition)
    .component('wowRecipeNavigation', require('./recipe-navigation.component').recipeNavigationComponentDefinition)
    .component('wowRecipeDetail', require('./recipedetail/recipe-detail.component').recipeDetailComponentDefinition)
    .component('wowRecipeDetailVideo', require('./recipedetail/recipe-detail-video.component').recipeDetailVideoComponentDefinition)
    .component('wowRecipeExportOptions', require('./recipedetail/recipe-detail-export-options.component').recipeDetailExportOptionsComponentDefinition)
    .component('wowRecipeEmailForm', require('./recipedetail/recipe-detail-email-form.component').recipeDetailFormComponentDefinition);

module.exports = recipeModuleName;



// WEBPACK FOOTER //
// ./src/recipe/recipe.module.js